import { useMemo } from 'react';
import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';
import { useCurrentUser } from './useCurrentUser';

export type { SongMatch } from '@aeon-karaoke/cloud-convex/songs';

/** The song a track resolved to: undefined while loading, null when the
 * pipeline has not identified it yet. */
export function useSongMatch(trackId: Id<'tracks'> | undefined) {
  return useQuery(api.songs.forTrack, trackId ? { trackId } : 'skip');
}

/** The match behind each of the caller's own tracks, keyed by track, for the
 * manager rows. One subscription for the whole list. */
export function useMySongMatches() {
  const { user } = useCurrentUser();
  const matches = useQuery(api.songs.mine, user ? {} : 'skip');
  return useMemo(() => new Map((matches ?? []).map((match) => [match.trackId, match])), [matches]);
}
